import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "container-full flex items-center justify-between flex-no-wrap px-6 py-2 sm:py-4",
  ref: "navRef"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center flex-shrink-1 text-white mr-6 truncate" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 font-semibold text-xl tracking-tight truncate ..." }, "Philipp Schulz")
], -1)
const _hoisted_3 = { class: "sm:flex gap-x-2 hidden self-end" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" LinkedIn ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" GitHub ")
const _hoisted_6 = { class: "sm:hidden" }
const _hoisted_7 = {
  key: 0,
  class: "absolute overflow-auto left-0 sm:hidden bg-gray-800 flex flex-col items-center w-full",
  style: {"top":"3.5rem"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" LinkedIn ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" GitHub ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!
  const _component_navigation_button = _resolveComponent("navigation-button")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_navigation_button, { to: "https://www.linkedin.com/in/philipp-schulz-5938a81b7/" }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createVNode(_component_fa, { icon: ['fab', 'linkedin'] })
        ]),
        _: 1
      }),
      _createVNode(_component_navigation_button, { to: "https://github.com/5chulzi" }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createVNode(_component_fa, { icon: ['fab', 'github'] })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.menuState)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.menuState = false), ["stop"])),
            class: "focus:outline-none p-2"
          }, [
            _createVNode(_component_fa, {
              icon: "times",
              size: "lg"
            })
          ]))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.menuState = true), ["stop"])),
            class: "focus:outline-none p-2"
          }, [
            _createVNode(_component_fa, {
              icon: "bars",
              size: "lg"
            })
          ]))
    ]),
    (_ctx.menuState)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_navigation_button, {
            class: "py-2",
            to: "https://www.linkedin.com/in/philipp-schulz-5938a81b7/"
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createVNode(_component_fa, { icon: ['fab', 'linkedin'] })
            ]),
            _: 1
          }),
          _createVNode(_component_navigation_button, {
            class: "py-2",
            to: "https://github.com/5chulzi"
          }, {
            default: _withCtx(() => [
              _hoisted_9,
              _createVNode(_component_fa, { icon: ['fab', 'github'] })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 512))
}